import { Injectable, isDevMode } from '@angular/core';

const KEY = 'authAdminToken';

@Injectable({ providedIn: 'root' })
export class TokenAdminService {
  storage = isDevMode() ? window.localStorage : window.sessionStorage;

  hasToken() {
    return !!this.getToken();
  }

  setToken(token: string) {
    this.storage.setItem(KEY, token);
  }

  getToken() {
    return this.storage.getItem(KEY);
  }

  removeToken() {
    this.storage.removeItem(KEY);
  }
}
